"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSecurityStore = void 0;
const pinia_1 = require("pinia");
const AuthenticatedUser_1 = __importDefault(require("./AuthenticatedUser"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const i18n_1 = require("../../common/i18n");
exports.useSecurityStore = (0, pinia_1.defineStore)('securityStore', {
    state: () => ({
        authenticatedUser: AuthenticatedUser_1.default.factory(),
        authCheck: false,
        authCheckLoading: false,
        authChecked: false,
        tokenLoading: false,
        payload: [],
    }),
    getters: {
        authenticated: (state) => {
            if (state.authenticatedUser === null) {
                return false;
            }
            return state.authChecked && !state.authCheck && state.authenticatedUser.isActive;
        },
    },
    actions: {
        login(router, email, password) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'security_login' }).href, {
                    method: 'POST',
                    body: JSON.stringify({ email: email, password: password })
                }).then(loginResponse => {
                    if (typeof loginResponse.error !== 'undefined') {
                        // login failed
                        reject((0, i18n_1.trans)('login_failed', 'Login failed. Please, check your email and password!', 'security'));
                        return;
                    }
                    this.authenticatedUser = AuthenticatedUser_1.default.factory(loginResponse.token);
                    resolve(this.checkAuth(router));
                }).catch(err => {
                    reject(err);
                });
            });
        },
        registration(router, registrationData) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "registration" }).href, {
                    method: "POST",
                    body: JSON.stringify(registrationData),
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then((registrationResponse) => {
                    if (registrationResponse && registrationResponse.id) {
                        resolve(registrationResponse);
                    }
                    else {
                        reject((0, i18n_1.trans)("registration_failed_try_again", "Registration Failed! Try again!", "registration"));
                    }
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        refreshToken(router) {
            this.tokenLoading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'security_refresh_token' }).href, { method: 'POST' }).then(refreshResponse => {
                    if (typeof refreshResponse.error !== 'undefined') {
                        // refresh failed
                        reject((0, i18n_1.trans)('authentication_expired', 'Your authentication is expired. Please login again!', 'security'));
                        return;
                    }
                    this.authenticatedUser = AuthenticatedUser_1.default.factory(refreshResponse.token);
                    this.tokenLoading = false;
                    resolve(refreshResponse);
                }).catch((e) => {
                    reject((0, i18n_1.trans)('authentication_expired', 'Your authentication is expired. Please login again!', 'security'));
                    this.logout(router, false);
                    this.tokenLoading = false;
                });
            });
        },
        logout(router, showLogin = true) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'security_logout' }).href)
                    .then(() => {
                    this.authenticatedUser = null;
                    this.authCheck = false;
                    this.authChecked = false;
                    if (showLogin && router.currentRoute.value.name !== 'app_login') {
                        router.push({ name: 'app_login' });
                        resolve(true);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        checkAuth(router) {
            this.authCheck = false;
            this.authCheckLoading = true;
            this.authChecked = false;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'security_check_auth' }).href)
                    .then((response) => {
                    this.payload = response.payload;
                    this.authCheckLoading = false;
                    this.authCheck = false;
                    this.authChecked = true;
                    resolve();
                })
                    .catch(error => {
                    this.authCheckLoading = false;
                    this.authCheck = false;
                    this.authChecked = true;
                    reject(error);
                });
            });
        },
        sendForgotPasswordEmail(router, payload) {
            let options = { body: JSON.stringify(payload.payload), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'send_forgot_password_email' }).href, options)
                    .then(response => {
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        resetPassword(router, payload) {
            let options = { body: JSON.stringify(payload), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'reset_password' }).href, options)
                    .then(response => {
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        }
    },
});
